import useVideoPlayPause from "@/hooks/useVideoPlayPause";

import styles from "./VideoItem.module.scss";

interface VideoItemProps {
  hidden?: boolean;
  url: string;
  poster: string;
}

const VideoItem = ({ hidden = false, url, poster }: VideoItemProps) => {
  const { videoRef } = useVideoPlayPause({ hidden });

  return (
    <div className={styles.root}>
      <img src={poster} alt="video poster" />
      <video
        muted={true}
        autoPlay={true}
        loop={true}
        playsInline={true}
        preload="auto"
        ref={videoRef}
        // default posters' position can't be controlled, so we use bg image
      >
        <source src={url} type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' />
      </video>
    </div>
  );
};

export default VideoItem;
